<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    role="presentation"
    class="cdr-icon_2.0.1 "
  >
    <path
      d="M8 11h8c.5522847 0 1 .4477153 1 1s-.4477153 1-1
      1H8c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1z"
    />
  </svg>
</template>

<script>
export default {
  name: 'MinusIcon',
};
</script>
